import { Component, computed, input, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-colored-amount',
  templateUrl: './colored-amount.component.html',
  styleUrl: './colored-amount.component.scss',
  standalone: false,
})
export class ColoredAmountComponent implements ICellRendererAngularComp {
  readonly amountValue = input<number>();

  private readonly _agAmount = signal<number>(0);

  protected readonly amount = computed(
    () => this.amountValue() ?? this._agAmount(),
  );

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams) {
    this._agAmount.set(params.value);
    return true;
  }
}
